import { render, staticRenderFns } from "./school-lookup.vue?vue&type=template&id=179b0fd7"
import script from "./school-lookup.vue?vue&type=script&lang=js"
export * from "./school-lookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports